import { WhatsappLogo, Phone, InstagramLogo, TiktokLogo } from "@phosphor-icons/react";

const WhatsAppButton = () => {
  const phoneNumber = "4917672636169";
  const message = encodeURIComponent("Hallo, ich habe Ihre Website gesehen und interessiere mich für Epoxidharz Böden.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  const instagramUrl = "https://www.instagram.com/pureepox?igsh=NDB6NWFzdmpoYTBn";
  const tiktokUrl = "https://www.tiktok.com/@pureepox?_r=1&_t=ZG-95m166DSpH6";

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      {/* TikTok Button */}
      <a
        href={tiktokUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black text-white p-4 rounded-full shadow-lg hover:bg-gray-800 transition-all duration-300 hover:scale-110 group"
        data-testid="tiktok-button"
        aria-label="TikTok besuchen"
        title="TikTok besuchen"
      >
        <TiktokLogo size={28} weight="fill" />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-2 bg-slate-900 text-white text-xs rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          TikTok
        </span>
      </a>

      {/* Instagram Button */}
      <a
        href={instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 text-white p-4 rounded-full shadow-lg hover:opacity-90 transition-all duration-300 hover:scale-110 group"
        data-testid="instagram-button"
        aria-label="Instagram besuchen"
        title="Instagram besuchen"
      >
        <InstagramLogo size={28} weight="fill" />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-2 bg-slate-900 text-white text-xs rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Instagram
        </span>
      </a>

      {/* Phone Button */}
      <a
        href="tel:+4916092653278"
        className="bg-sky-700 text-white p-4 rounded-full shadow-lg hover:bg-sky-800 transition-all duration-300 hover:scale-110 group"
        data-testid="phone-button"
        aria-label="Jetzt anrufen"
        title="Jetzt anrufen"
      >
        <Phone size={28} weight="fill" />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-2 bg-slate-900 text-white text-xs rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          Jetzt anrufen
        </span>
      </a>

      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#20bd5a] transition-all duration-300 hover:scale-110 group"
        data-testid="whatsapp-button"
        aria-label="WhatsApp Kontakt"
        title="Kontakt über WhatsApp (externer Dienst)"
      >
        <WhatsappLogo size={28} weight="fill" />
        <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-2 bg-slate-900 text-white text-xs rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          WhatsApp (externer Dienst)
        </span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
